import { environment } from '../environments/environment';

export class AppConfig {
  public static readonly AuthTokenLocation = 'wiProjectsPlatformToken';
  // Survives the logout wipe on purpose — see AppGlobals.ClearClientSession.
  public static readonly ReleaseNoticeKey = 'lastSeenReleaseVersion';
  public static readonly AppEnvironment = 'WIProjects.WebApp';
  // ponytail: not readonly — set once at startup by loadAppVersion() from /assets/version.json.
  public static APPVersion = '0.0.0-dev';
  public static readonly APIEndPointBase = environment.apiURL;
  public static readonly SiteBase = window.location.origin;
  public static readonly ClientId = 'a57ccc04-dc82-418a-a22e-9a666fa8d960';
  public static readonly sharedWikiTenantId = 'B7923DA1-E939-4F2D-B577-F322150532F5';
  public static readonly MaxFileNameLength = 70;

}
